import '../resources/css/teaser.css';
import Separator from './shared/Separator';
import Button from './shared/Button';
import parse from 'html-react-parser';

export default function Teaser({ data }) {

    const { image, title, text, button } = data;

    const parsedText = parse(text || '');

    return (
        <div className="teaser">
            <div>
                <div className="title-h1">{title}</div>
                <div>
                    <Separator className="color-blue"></Separator>
                </div>
                {
                    title && parsedText
                }
                {
                    button &&
                    <div className="teaser-btn">
                        <Button href={button.path} type={button.type}>{button.text}</Button>
                    </div>
                }

            </div>
            <div className="teaser-img">
                <img src={image} alt="welcome"></img>
            </div>

        </div >);
};